import { Column, Index } from 'typeorm';

import { ApiProperty } from '../../codegen';
import { IsDate, IsNumber, IsString } from '../../validators';
import { BasicEntity } from '../basic/basic.entity';

@Index(['userId', 'deviceIdHash'], { unique: true })
export class UserDeviceStat extends BasicEntity {
  @ApiProperty()
  @IsNumber({}, { groups: ['error'] })
  @Column({ type: 'int', nullable: false })
  userId: number;

  @ApiProperty()
  @IsString({ groups: ['error'] })
  @Index()
  @Column({ type: 'varchar', nullable: false })
  deviceIdHash: string;

  @ApiProperty()
  @IsDate({ groups: ['error'] })
  @Column({ type: 'timestamptz', nullable: false, precision: 3 })
  firstSeenAt: Date;

  @ApiProperty()
  @IsDate({ groups: ['error'] })
  @Column({ type: 'timestamptz', nullable: false, precision: 3 })
  lastSeenAt: Date;

  @ApiProperty()
  @IsNumber({}, { groups: ['error'] })
  @Column({ type: 'int', nullable: false, default: 0 })
  requestCount: number;
}
